const JobStatus = {
  IDLE: 0,
  WAITING: 1,
  RUNNING: 2,
  FAILED: 3,
  COMPLETED: 4,
};

export default JobStatus;
